module.exports = __webpack_public_path__ + "img/metodos_pago.566ceb9d.svg";